import { colors } from "#app/theme/v1/colors";
import { SimilarPartFeedbackButtons } from "#modules/feedback/view/SimilarPartFeedbackButtons";
import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { QuoteRequestLinesSimilarPartDto } from "#modules/similarPart/infra/searchQuoteRequestLineSimilarParts.api";
import { ClusterCardData } from "#modules/similarPart/view/clustering/ClusterCardData";
import { ClusterCardHeader } from "#modules/similarPart/view/clustering/ClusterCardHeader";
import { Paper } from "#shared/view/components/Paper";
import { Stack } from "#shared/view/components/Stack";
import { ThumbnailOverlay } from "#shared/view/components/Thumbnails/ThumbnailOverlay";

import { DetailedManufaturingRangeButton } from "../ResultModal/DetailedManufaturingRangeButton";

export const ClusterCard = ({
  handleToggleSelect,
  targetPart: quoteRequestLine,
  isSelected,
  sourcePart,
  index,
}: {
  handleToggleSelect?: () => void;
  sourcePart?: PartDto | null;
  targetPart: QuoteRequestLinesSimilarPartDto;
  isSelected?: boolean;
  index: number;
}) => {
  const isSamePart = (quoteRequestLine.cosineSimilarity || 0) === 1;

  return (
    <Paper
      p="xxs"
      withBorder
      radius={10}
      onClick={handleToggleSelect}
      style={
        isSelected
          ? { ...selectedCard, ...pointer }
          : isSamePart
            ? { ...sameCard, ...pointer }
            : pointer
      }
    >
      <Stack gap={"xxs"} justify="space-between">
        <ClusterCardHeader quoteRequestLine={quoteRequestLine} />

        <ThumbnailOverlay
          size={{ width: "100%", height: "100%" }}
          part={quoteRequestLine.part}
          quoteRequestLineId={quoteRequestLine.id}
        />

        <ClusterCardData quantity={quoteRequestLine.quantity}>
          <ClusterCardData.Chips quoteRequestLine={quoteRequestLine} />
          <ClusterCardData.Quantity quantity={quoteRequestLine.quantity} />
          <ClusterCardData.Features quoteRequestLine={quoteRequestLine} />
        </ClusterCardData>

        <DetailedManufaturingRangeButton quoteRequestLineId={quoteRequestLine.id} />
        {sourcePart && (
          <SimilarPartFeedbackButtons
            sourcePartId={sourcePart.id}
            targetPartId={quoteRequestLine.partId}
            index={index}
          />
        )}
      </Stack>
    </Paper>
  );
};

const selectedCard = {
  backgroundColor: colors.blue[0],
  borderColor: colors.blue[4],
};

const sameCard = {
  backgroundColor: colors.green[1],
  borderColor: colors.green[4],
};

const pointer = {
  cursor: "pointer",
};
